<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    span.green{
        background: green;
        color: #fff;
    }
    span.on{
        background: green;
        color:#fff
    }
    span{
        display: inline-block;
        width: 30px;
        height: 30px;
        padding: 5px 10px;
        margin: 2px 0;
        text-align: right;
    }
    .date-box{
        width: 100%;
        position: relative;
        text-align: left;
    }

</style>
<template>
    <div class="date-box">
        <div v-for="(item,index) in data" v-if="item.length>0">
            <h4>{{monthName[index]}}</h4>
            <span v-for="it in item[0].week"></span>
            <span v-for="(items,ind) in item" @click="setTime(items,ind)" :class="{'gray':items.status,'on':items.selected,'green':(!items.status)&&items.time>=start&&items.time<=end}">
                {{items.day}}
            </span>
        </div>
    </div>
</template>
<script>
    export default {
        name: '',
        data() {
            return {
                time:parseInt(new Date().getTime()/(86400*1000))*86400*1000 - 31*86400*1000 - 28800000,
                data:[],
                cacheDate:[],
                month:new Date().getMonth(),
                monthName:['一','二','三','四','五','六','七','八','九','十','十一','十二'],
                status:false
            }
        },
        props: ['start','end','success','error'],
        methods: {
            getDate: function () {
                let _this = this,arr = []
                for(let n =0;n<12;n++){
                    arr[n] = []
                }
                for(let i = 0; i < 31; i++){
                    let date = _this.time + i*86400*1000
                    let days = new Date(date),obj = {}
                    if(days.getMonth() == _this.month){
                        obj = {
                            month:days.getMonth(),
                            day:days.getDate(),
                            time:date,
                            week:days.getDay(),
                            status:true,
                            selected:false
                        }
                        arr[days.getMonth()].push(obj)
                    }
                }
                for(let k = 1; k < 120; k++){
                    let date = _this.time + (30+k)*86400*1000
                    let days = new Date(date),obj = {}
                    if(days.getMonth() < (_this.month+4)){
                        obj = {
                            month:days.getMonth(),
                            day:days.getDate(),
                            time:date,
                            week:days.getDay(),
                            selected:false
                        }
                        if(k<90){
                            obj.status = false
                        }else{
                            obj.status = true
                        }
                        arr[days.getMonth()].push(obj)
                    }
                }
                this.data = arr
            },
            setTime: function (obj,ind) {
                if($(event.currentTarget).hasClass('gray')){
                    return false
                }
                if(!this.status){
                    this.getStartTime(obj,ind)
                }else{
                    if((obj.time - this.start)/86400000 > 30){
                        if(this.error){
                            this.error()
                        }
                        return false
                    }
                    if(this.start < obj.time){
                        if(this.success){
                            this.success()
                        }
                        this.end = obj.time
                        this.status = false
                    }else{
                        this.getStartTime(obj,ind)
                    }
                }
            },
            getStartTime: function (obj,ind){
                let arr = []
                this.getDate()
                for(let i = 0; i < this.data.length; i++){
                    arr[i] = this.data[i]
                }
                this.start = obj.time
                this.end = ''
                this.status = true
                arr[obj.month][ind].selected = true
                this.data = arr
            }
        },
        components: {},
        mounted() {
            this.$nextTick(function() {
                this.getDate()
            })
        },
        created() {

        }
    }
</script>


// WEBPACK FOOTER //
// date.vue?390c5168